import axios from "axios";
import { ADD_ACCREDITATIONS_API, ADD_CURRENCY_API, ADD_LANGUAGE_API, ADD_SPECIALITIES_API, ADMIN_LOGIN_API, ADMIN_LOGOUT_API, BLOCK_UNBLOCK_USER_API, CHANGE_PASSWORD_API, CURRENCY_LIST_API, DASHBOARD_API, DELETE_ACCREDITATIONS_API, DELETE_CURRENCY_API, DELETE_LANGUAGE_API, DELETE_SPECIALITIES_API, GET_ACCREDITATIONS_API, GET_LANGUAGE_API, GET_SPECIALITIES_API, REFRESH_TOKEN_API, UPDATE_ACCREDITATIONS_API, UPDATE_CURRENCY_API, UPDATE_LANGUAGE_API, UPDATE_SPECIALITIES_API, USER_DETAIL_API, USER_LIST_API } from "./Api";

axios.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("coach-admin-token");
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  
  axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;
  
      if (error.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true;
  
        try {
          const refreshToken = localStorage.getItem("coach-admin-refresh-token");
  
          const res = await axios.get(REFRESH_TOKEN_API, {
            params: {
              refresh_token: refreshToken
            }
          });
  
          const newAccessToken = res.data.access_token;
  
          localStorage.setItem("coach-admin-token", newAccessToken);
  
          originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
  
          return axios(originalRequest);
  
        } catch (refreshError) {
          console.error("Refresh token failed:", refreshError);
  
          localStorage.removeItem("coach-admin-token");
          localStorage.removeItem("coach-admin-refresh-token");
  
          window.location.href = `/login`;
          return Promise.reject(refreshError);
        }
      }
  
      return Promise.reject(error);
    }
  );
  

  const headers = {
    "Content-type": "application/json",
  };


  
  export const adminLoginApi = (param) => {
    return axios.post(ADMIN_LOGIN_API, param);
  };

  export const adminLogoutApi = () => {
    return axios.post(ADMIN_LOGOUT_API, {
      headers: headers,
    });
  };

  export const dashboardApi = () => {
    return axios.get(DASHBOARD_API, {
      headers: headers,
    });
  };  

  export const userListApi = (param) => {
    return axios.get(USER_LIST_API, {
      headers: headers,
      params: param,
    });
  };

  export const changePasswordApi = (param) => {
    return axios.put(CHANGE_PASSWORD_API, param, {
      headers: headers,
    });
  };

  export const userDetailApi = (param) => {
    return axios.get(USER_DETAIL_API, {
      headers: headers,
      params: param,
    });
  };

  export const blockUnblockUserApi = (param) => {
    return axios.patch(BLOCK_UNBLOCK_USER_API, param, {
      headers: headers,
    });
  };

  export const addLanguageApi = (param) => {
    return axios.post(ADD_LANGUAGE_API, param, {
      headers: headers,
    });
  };

  export const getLanguageApi = (param) => {
    return axios.get(GET_LANGUAGE_API, {
      headers: headers,
      params: param,
    });
  };

  export const updateLanguageApi = (param) => {
    return axios.put(UPDATE_LANGUAGE_API, param, {
      headers: headers,
    });
  };

  export const deleteLanguageApi = (param) => {
    return axios.delete(DELETE_LANGUAGE_API, {
      headers: headers,
      params: param,
    });
  };

  export const getSpecialitiesApi = (param) => {
    return axios.get(GET_SPECIALITIES_API, {
      headers: headers,
      params: param,
    });
  };

  export const addSpecialitiesApi = (param) => {
    return axios.post(ADD_SPECIALITIES_API, param, {
      headers: headers,
    });
  };

  export const updateSpecialitiesApi = (param) => {
    return axios.put(UPDATE_SPECIALITIES_API, param, {
      headers: headers,
    });
  };

  export const deleteSpecialitiesApi = (param) => {
    return axios.delete(DELETE_SPECIALITIES_API, {
      headers: headers,
      params: param,
    });
  };

  export const getAccreditationsApi = (param) => {
    return axios.get(GET_ACCREDITATIONS_API, {
      headers: headers,
      params: param,
    });
  };

  export const updateAccreditationsApi = (param) => {
    return axios.put(UPDATE_ACCREDITATIONS_API, param, {
      headers: headers,
    });
  };

  export const addAccreditationsApi = (param) => {
    return axios.post(ADD_ACCREDITATIONS_API, param, {
      headers: headers,
    });
  };

  export const deleteAccreditationsApi = (param) => {
    return axios.delete(DELETE_ACCREDITATIONS_API, {
      headers: headers,
      params: param,
    });
  };

  export const getCurrencyListApi = (param) => {
    return axios.get(CURRENCY_LIST_API, {
      headers: headers,
      params: param,
    });
  };

  export const updateCurrencyApi = (param) => {
    return axios.put(UPDATE_CURRENCY_API, param, {
      headers: headers,
    });
  };

  export const addCurrencyApi = (param) => {
    return axios.post(ADD_CURRENCY_API, param, {
      headers: headers,
    });
  };

  export const deleteCurrencyApi = (param) => {
    return axios.delete(DELETE_CURRENCY_API, {
      headers: headers,
      params: param,
    });
  };